export default "__VITE_ASSET__CgyPGsoR__"